/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeclinePricingAgreementRequest
 */
export interface DeclinePricingAgreementRequest {
  /**
   *
   * @type {string}
   * @memberof DeclinePricingAgreementRequest
   */
  agreementId: string;
  /**
   *
   * @type {string}
   * @memberof DeclinePricingAgreementRequest
   */
  declineReason?: string | null;
}

/**
 * Check if a given object implements the DeclinePricingAgreementRequest interface.
 */
export function instanceOfDeclinePricingAgreementRequest(
  value: object,
): value is DeclinePricingAgreementRequest {
  if (!("agreementId" in value) || value["agreementId"] === undefined)
    return false;
  return true;
}

export function DeclinePricingAgreementRequestFromJSON(
  json: any,
): DeclinePricingAgreementRequest {
  return DeclinePricingAgreementRequestFromJSONTyped(json, false);
}

export function DeclinePricingAgreementRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DeclinePricingAgreementRequest {
  if (json == null) {
    return json;
  }
  return {
    agreementId: json["agreementId"],
    declineReason:
      json["declineReason"] == null ? undefined : json["declineReason"],
  };
}

export function DeclinePricingAgreementRequestToJSON(
  json: any,
): DeclinePricingAgreementRequest {
  return DeclinePricingAgreementRequestToJSONTyped(json, false);
}

export function DeclinePricingAgreementRequestToJSONTyped(
  value?: DeclinePricingAgreementRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    agreementId: value["agreementId"],
    declineReason: value["declineReason"],
  };
}
